
import axios from 'axios'

export default {
    getGroup(){
        return axios.get('/groupyouth')
            .then(response => {
                return response.data
            })
    },
    getGroupDataSource(params){
        return axios.get('/groupyouth/datasource', {params})
            .then(response => {
                return response.data
            })
    },
    getGroupbyID(id){
        return axios.get('/groupyouth/' + id)
            .then(response => {
                return response.data
            })
    },    
    createGroup(formdata){
        return axios.post('/groupyouth', formdata)
            .then(response => {
                return response.data
            })
    },
    updateGroup(id,formdata){
        return axios.put('/groupyouth/' + id, formdata)
            .then(response => {
                return response.data
            })
    },
    deactivateGroup(id){
        return axios.put('/groupyouth/' + id + '/deactivate')
            .then(response => {
                return response.data
            })
    },
    reactivateGroup(id){
        return axios.put('/groupyouth/' + id + '/reactivate')
            .then(response => {
                return response.data
            })
    },
    updateCoach(id,formdata){
        return axios.put('/groupyouth/' + id + '/manage-coach' ,formdata)
            .then(response => {
                return response.data
            })
    },
    updateIcare(id,formdata){
        return axios.put('/groupyouth/' + id + '/manage-icare',formdata)
            .then(response => {
                return response.data
            })
    },
    
   
}